module.exports = __webpack_public_path__ + "static/dog-e7ed515b22469fc837b66bb1f133fb0d.png";